
import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';

export const tooltipDefaults: MatTooltipDefaultOptions = {
    showDelay: 1000,
    hideDelay: 1000,
    touchendHideDelay: 1000,
};


@Component({
    selector: 'app-toggle-button',
    templateUrl: './toggle-button.component.html',
    styleUrls: ['./toggle-button.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleButtonComponent),
            multi: true,
        },
        { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: tooltipDefaults }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToggleButtonComponent implements OnInit, ControlValueAccessor {

    @Output()
    public valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    public on: boolean = false;

    onChange: any = () => { this.valueChange.emit(this.value); };
    onTouch: any = () => { };

    @Input()
    public position: 'center' | 'left' | 'right' = 'center';

    @Input()
    public disabled: boolean = false;

    _value: boolean;

    set value(val) {
        if (val !== undefined && this._value !== val) {
            this._value = val;
            this.onChange(val);
            this.onTouch(val);
        }
    }

    get value(): boolean {
        return this._value;
    }

    @Input()
    public textOn: string;

    @Input()
    public textOff: string;


    _onIcon: any = ['fas', 'bars'];

    @Input()
    public get onIcon(): any {
        if (this._onIcon === undefined) { return ['fas', 'bars']; };

        return this._onIcon;
    }

    public set onIcon(value: any) {
        this._onIcon = value;
    }


    _offIcon: any = ['fas', 'bars'];

    @Input()
    public get offIcon(): any {
        if (this._offIcon === undefined) { return ['fas', 'bars']; }

        return this._offIcon;
    }

    public set offIcon(value: any) {
        this._offIcon = value;
    }

    @Input()
    isToggle: boolean = true;

    @Input()
    tooltip: string;

    constructor(private cd: ChangeDetectorRef) { }

    // this method sets the value programmatically
    writeValue(value: any): void {
        this.value = value;
    }
    // upon UI element value changes, this method gets triggered
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    // upon touching the element, this method gets triggered
    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    setDisabledState?(isDisabled: boolean): void {

    }

    ngOnInit(): void {
        setInterval(() => {
            this.cd.detectChanges();
        }, 500);
    }

    toggle(): void {
        if (this.isToggle) {
            this.value = !this.value;
        } else {
            this.onChange(false);
        }
    }
}
